import React from "react";
import { Card } from "../";
import { baseUrl } from "../../constants";
import "./SocialHandles.css";

const sources = [
  {
    src: `/image/instagram.jpg`,
    link: "http://instagram.com/hlad_nitkkr",
    name: "Instagram",
  },
  {
    src: `/image/youtube.png`,
    link: "https://www.youtube.com/@HLADNITKKR",
    name: "Youtube",
  },
  {
    src: `/image/facebook.jpg`,
    link: "https://www.facebook.com/hladcnitkkr/",
    name: "Facebook",
  },
];

const SocialHandels = ({ cardScale, flexDirection }) => {
  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <div
        style={{
          display: "flex",
          // flexDirection: `${flexDirection||"row"}`,
          justifyContent: "center",
          flexWrap: "wrap",
          minWidth: "70vw",
          alignSelf: "center",
        }}
      >
        {sources.map((s, i) => (
          <div key={i} style={{ margin: "0px 30px" }}>
            <Card
              mainText={s.name}
              scale={cardScale || 0.8}
              subText=""
              bodyText=""
              photoUrl={s.src}
            >
              <a
                href={s.link}
                target="_blank"
                style={{ borderWidth: "1px", borderColor: "rgb(59, 130, 246)" }}
                className="px-4 py-1 my-2 bg-blue-500 text-white text-sm hover:text-blue-500 hover:bg-white rounded-full"
              >
                Visit
              </a>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialHandels;
